// users

const mutations = {
	getUsers(state, objects) {
  		state.users = objects;
	},
	getUser(state, object) {
  		state.user = object;
	},
	resetUser(state) {
  		state.user = {};
	},
	getRoles(state, objects) {
		state.roles = objects;
  	},
  	getTeams(state, objects) {
		state.teams = objects;
	},

};

export default mutations;